import React, { useState, useEffect, useContext } from "react";
import { FormControlLabel, Checkbox, TextField, MenuItem, Slide, InputAdornment, Menu, Dialog, Radio, Button, DialogContent, DialogActions, Typography, DialogTitle, FormControl, RadioGroup } from "@mui/material";
import { Link, useNavigate, useParams } from 'react-router-dom';
import EmailIcon from '@mui/icons-material/Email';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { ReactComponent as WhatsappFilled } from '../../../../Assets/img/icons/whatsapp-filled.svg';
import { ReactComponent as VideoCallFilled } from '../../../../Assets/img/icons/video-call-figma.svg';
import ForumIcon from '@mui/icons-material/Forum';
import { ReactComponent as GroupChatFilled } from '../../../../Assets/img/icons/group-chat-figma.svg';
import { ReactComponent as VideoTutorialFilled } from '../../../../Assets/img/icons/video-tutorial-figma.svg';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import VolumeUpRoundedIcon from '@mui/icons-material/VolumeUpRounded';
import BlockIcon from '@mui/icons-material/Block';
import DeleteIcon from '@mui/icons-material/Delete';
import { FaSearch } from "react-icons/fa";
import CloseIcon from '@mui/icons-material/Close';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
// import { useNavigate } from 'react-router-dom';
// import useApi from '../../../Utilities/useAPI';
import Avatar from '@mui/material/Avatar';
import { ContactsDetContext } from '../../../ContactsDetContext';
import SpeedDialComponent from "./SpeedDialComponent";
// import AddNewContact from "./SubPages_Contacts/AddNewContact";
import axios from "axios";
import { useQuantityContext } from "../../../QuantityContext";
import useApi from "../../../Utilities/useAPI";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setActiveConversation } from "../../../../Redux/Reducers/ContactReducer";
import { setCurrentConversation } from "../../../../Redux/Reducers/cceReducer";


function AllGroupDetails() {
    const dispatch=useDispatch()
    const apiKey = process.env.REACT_APP_API_KEY
    const objectId = localStorage.getItem("objectId");
    const headers = {
        'x-api-key': apiKey,
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${objectId}`
    };
    // const { groupsAll } = useContext(ContactsDetContext);
    const { handleInfo, sortDateOrder, sortOrder, latestDateOrder } = useQuantityContext();
    const [selectedGroup, setSelectedGroup] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [selectCheckBox, setSelectCheckBox] = useState(false);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [groupsAll, setGroupsAll] = useState([]);
    const [showOptionsBar, setShowOptionsBar] = useState(false)
    const [selectAllContacts, setSelectAllContacts] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedGroupData,setSelectedGroupData]=useState([])
    const isMenuOpen = Boolean(anchorEl);
    const [deleteConfirm, setdeleteConfirm] = useState(false);
    const [muteContact, setMuteContact] = useState(false);
    const { callApiFunction } = useApi();
    const navigate = useNavigate();
    
    const ContactGroups = useSelector((state) => state?.ContactArray?.ContactGroup);
    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    // console.log("ContactGroupsDATA", ContactGroups)
    // console.log("SELECTED GROUP", selectedGroup, selectCheckBox, selectedGroups, groupsAll, selectedGroupData)

//    console.log("IAMhandleNavigate",  selectedGroupData)

    const handleGroundChat=()=>{

         const updatedConversationItem = {
          avatar:selectedGroupData[0]?.group_image,
          title:selectedGroupData[0]?.name,
        };
      
 dispatch(setCurrentConversation(updatedConversationItem));
       // Navigate to OneToOneChat route with member data
    navigate('/connect-chat', { state: {selectedGroupData}  });
                            
    }

    const cceFunctions = [
        { icon: VideoCallFilled, function: undefined },
        { icon: WhatsappFilled, function: undefined },
        { icon: ForumIcon, function: undefined },
        { icon: GroupChatFilled, function: handleGroundChat },
        { icon: AttachFileIcon, function: undefined },
        { icon: VideoTutorialFilled, function: undefined },
        { icon: VolumeUpRoundedIcon, function: undefined },
        { icon: EmailIcon, function: undefined },
    ];
    const handleGroupChange = (event) => {
        const value = event.target.value;
        setSelectedGroup(value === "" ? "All Groups" : value);  // Default to "All Groups" if none is selected
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleSelectCheckboxChange = (event) => {
        const checked = event.target.checked;
        setSelectCheckBox(checked);
        setSelectedGroups([]);
    };


    useEffect(() => {
        // Fetch contacts from the API
        const fetchContacts = async () => {
            // try {
            //   const response = await callApiFunction('ConnectedContacts');

            //   const data = response;
            //   if (data.statusCode === 200) {
            //     const members = data.data.map(member => {
            //       // Logic for role and subTitle
            //       const role = member.designation || member.field_of_study || member.title || '---';  // Updated role logic
            //       const subTitle = member.profession_department || member.institute || member.nickname || '---';  // New subTitle logic

            //       return {
            //         id: member.id,
            //         contact_ref_id: member.contact_ref_id,
            //         img: member.profile_url,  // Fallback to default image if profile URL is null
            //         is_favourite: member?.is_favourite ? true : false,
            //         name: `${member.first_name} ${member.last_name}`,
            //         role: role,  // Based on new logic
            //         email: `${member.first_name.toLowerCase()}.${member.last_name.toLowerCase()}@example.com`,  // Mock email as it's not provided
            //         verified: member.is_verified ? true : false,
            //         neoin_id: member.unique_id,
            //         subTitle: subTitle  // Add new subTitle field
            //       };
            //     });
            //     setConnectedContacts(members)

            //     const unverifiedMembers = members.filter(member => !member.verified);
            //     setUnverifiedContacts(unverifiedMembers);
            //     setUnVerifedCount(unverifiedMembers.length);

            //     // Filter and set favorite contacts
            //     const favoriteMembers = members.filter(member => member.is_favourite);
            //     setFavoriteContacts(favoriteMembers);
            //   }
            // } catch (err) {
            //   console.log('An error occurred while sending the connection request:', err);
            // }

            try {
                // const response = await callApiFunction('fetchGroupDetails');

                // if (response?.statusCode === 200) {
                // Map the response data to extract group name and URL
                const backendGroups = ContactGroups.map(group => ({
                    name: group.group_name,
                    url: group.group_url,
                    id: group.id,
                    group_image: group.group_image,
                    // persons: personsData,
                    persons: group.members.map(member => ({
                        img: member.profile_url, // Use a placeholder if profile_url is null
                        name: `${member.first_name} ${member.last_name}`,
                    })),
                    count: group.count,
                }));

                setGroupsAll(backendGroups);
                // } else {
                // console.log('Error fetching groups:');
                // }
            } catch (error) {
                console.error('Error:', error);
            }

            // try {
            //     const response = await callApiFunction('getConnectionsMethods');

            //     if (response.statusCode === 200) {
            //         // Map the response data to extract group name and URL
            //         const formattedGroups = formatGroupsData(response.data);
            //         setCardConnectMember(formattedGroups);
            //         console.log("Connection Methds", response);
            //     } else {
            //         console.log('Error fetching groups:');
            //     }
            // } catch (error) {
            //     console.error('Error:', error);
            // }

        };

        fetchContacts();
    }, []);

    const handleGroupSelectChange = (group) => (event) => {
        const checked = event.target.checked;

        // Update the selected group names (used elsewhere)
        setSelectedGroups(prevSelectedGroups => {
            let newSelectedGroups;

            if (checked) {
                newSelectedGroups = [...prevSelectedGroups, group.name];
            } else {
                newSelectedGroups = prevSelectedGroups.filter(name => name !== group.name);
            }

            // Show options bar only when exactly one group is selected
            setShowOptionsBar(newSelectedGroups.length === 1);

            return newSelectedGroups;
        });

        // Update the selected group data (store full group objects)
        setSelectedGroupData(prev => {
            if (checked) {
                return [...prev, group];
            } else {
                return prev.filter(g => g.id !== group.id);
            }
        });
    };

    const getFilteredGroups = () => {
        let filteredGroups = groupsAll;

        if (selectedGroup && selectedGroup !== "All Groups") {
            filteredGroups = filteredGroups.filter(group => group.name === selectedGroup);
        }

        if (searchTerm) {
            filteredGroups = filteredGroups.filter(group =>
                group.name.toLowerCase().includes(searchTerm.toLowerCase()) ||  // Check group name
                group.persons.some(person => person.name.toLowerCase().includes(searchTerm.toLowerCase()))  // Check persons' names
            );
        }
        // console.log(filteredGroups);


        return filteredGroups;
    };

    const filteredGroups = getFilteredGroups();


    useEffect(() => {
        // console.log("SORTED STATUS", sortOrder);

        if (sortOrder !== null) {
            // Extract group names or the necessary data
            const sortedCards = filteredGroups.sort((a, b) => {
                if (sortOrder === 'ascending') {
                    return a.name.localeCompare(b.name); // Replace with the correct property
                } else {
                    return b.name.localeCompare(a.name); // Replace with the correct property
                }
            });

            // console.log("Sorted Cards:", sortedCards);
            // setOtherCards(sortedCards);
            // Uncomment this to update the state
        }
    }, [sortOrder, filteredGroups]);


    useEffect(() => {
        if (sortDateOrder !== null) {
            const sortedCards = filteredGroups.sort((a, b) => {
                const dateA = new Date(a.created_at);
                const dateB = new Date(b.created_at);

                return sortDateOrder === 'ascending' ? dateA - dateB : dateB - dateA;
            });

            // console.log("Sorted by Created Date:", sortedCards);
            // setOtherCards(sortedCards); 
            // Uncomment to update state
        }
    }, [sortDateOrder, filteredGroups]);


    useEffect(() => {
        if (latestDateOrder !== null) {
            const sortedCards = filteredGroups.sort((a, b) => {
                const dateA = new Date(a.modified_at);
                const dateB = new Date(b.modified_at);

                return latestDateOrder === 'latestDate' ? dateB - dateA : dateA - dateB;
            });

            // console.log("Sorted by Modified Date:", sortedCards);
            // setOtherCards(sortedCards); 
            // Uncomment to update state
        }
    }, [latestDateOrder, filteredGroups]);

    // Utility function to get selected group IDs
    const getSelectedGroupIds = (selectedGroups, filteredGroups) => {
        return selectedGroups
            .map(groupName => {
                const group = filteredGroups.find(group => group.name === groupName);
                return group ? group.id : null; // Get the group ID based on the group name
            })
            .filter(id => id !== null); // Filter out null values
    };

    // Example usage
    const handleDelete = async () => {
        setdeleteConfirm(false);

        // Call the utility function to get selected group IDs
        const selectedGroupIds = getSelectedGroupIds(selectedGroups, filteredGroups);
        // console.log("Selected group IDs:", selectedGroupIds);

        try {
            // Loop over the selected group IDs and delete them one by one
            for (const groupId of selectedGroupIds) {
                const response = await axios.delete(
                    `${process.env.REACT_APP_BACKEND_URL}/usercontact/groups/deleteGroup/${groupId}`,
                    {
                        headers: headers,
                    }
                );
                // console.log(`Group with ID ${groupId} deleted successfully`, response.data.statusCode);
                if (response.data.statusCode === 200) {
                    setSelectedGroups([]);
                    setShowOptionsBar(false);
                    navigate('/contacts');
                }
            }

            // Clear selected groups after deletion


        } catch (error) {
            console.error('Error deleting group:', error.message);
            // alert("Alert" + response.message);
            setSelectedGroups([]);
            setShowOptionsBar(false);
            setSelectCheckBox(false);
            handleInfo("Only the group admin can delete this group.");
        }
    };

    return (
        <>
            <div className="outer-layer-of-contacts">
                <div className="outer-container">
                    <div className="displayflex justify-content-between align-items-center">
                        <h6 className="fw-bold">All Groups</h6>
                        <div className="flex-center">
                            <div className="">
                                {/* {selectCheckBox && <FormControlLabel
                                    control={<Checkbox checked={selectAllContacts} onChange={handleSelectedcontacts} />}
                                    label="Select All"
                                />} */}
                                <FormControlLabel
                                    control={<Checkbox checked={selectCheckBox} onChange={handleSelectCheckboxChange} />}
                                    label="Select"
                                />
                            </div>
                            <div style={{ marginRight: '10px' }}>
                                <TextField
                                    placeholder="Search..."
                                    variant="outlined"
                                    size="small"
                                    className="me-2"
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <div className="icon">
                                                    <FaSearch className="icon-color" />
                                                </div>
                                            </InputAdornment>
                                        ),
                                    }}
                                    style={{ width: '320px' }}
                                />
                            </div>
                            <div className="dropdowngroup">
                                <TextField
                                    select
                                    variant="outlined"
                                    size="small"
                                    className="mr-2"
                                    value={selectedGroup}
                                    onChange={handleGroupChange}
                                    label="All Folders"
                                    style={{ width: '136px' }}
                                >
                                    <MenuItem value="All Groups">
                                        All Groups
                                    </MenuItem>
                                    {groupsAll.map((group, index) => (
                                        <MenuItem key={index} value={group.name}>
                                            {group.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </div>
                        </div>
                    </div>

                    <div className="mt-4">
                        <div className="contact-groups">
                            {filteredGroups.map((group, index) => (
                                <>
                                    <div className="group" key={index}>
                                        <div className="person-box">
                                            {selectCheckBox && (
                                                <Checkbox
                                                    checked={selectedGroups.includes(group.name)}
                                                    onChange={handleGroupSelectChange(group)}
                                                    className="group-checkbox"
                                                />
                                            )}
                                            <Link to={`/groupContacts/${group.id}`} className="group-link">
                                                <div className={`person-grid ${selectCheckBox ? 'select-all' : ''}`}>
                                                    {group.persons.slice(0, 6).map((person, idx) => (
                                                        <Avatar
                                                            // className="person-image"
                                                            sx={{ width: 32, height: 32 }}
                                                            key={idx}
                                                            alt={person.name}
                                                            src={person.img || undefined} // Only provide src if person.img is valid
                                                        >{person.name.charAt(0).toUpperCase()}</Avatar>
                                                    ))}
                                                </div>
                                                <div className="person-details fw-bold truncate">
                                                    {group.name}
                                                </div>
                                                <div className="person-details-2">
                                                    {group.count} contacts
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </>
                            ))}


                            {selectedGroups.length > 0 &&
                                <div className={`action-bar cce-actions ${selectedGroups.length > 0 ? 'open' : ''}`}>
                                    {cceFunctions.map((item, index) => {
                                        const SvgIcon = item.icon; // Get the component reference
                                        return (
                                            <a href={item.href} target="_blank" rel="noreferrer" key={index}>
                                                <IconButton className="white-icon-hover me-4" onClick={item.function} key={index}>
                                                    <SvgIcon className='white-svg svg-icon-32px' />
                                                </IconButton>
                                            </a>
                                        )
                                    })}

                                    <IconButton className="white-icon-hover me-4 position-absolute end-0" onClick={handleMenuOpen}>
                                        <MoreVertIcon className='white-svg svg-icon-32px' />
                                    </IconButton>

                                    {/* Overflow Menu */}
                                    <Menu
                                        id="overflow-menu"
                                        anchorEl={anchorEl}
                                        open={isMenuOpen}
                                        onClose={handleMenuClose}
                                        MenuListProps={{
                                            'aria-labelledby': 'overflow-menu-button',
                                        }}
                                    >
                                        <MenuItem
                                            onClick={() => {
                                                setdeleteConfirm(true);
                                                handleMenuClose();
                                            }}
                                            style={{ color: '#0044C6' }}
                                        >
                                            <DeleteIcon className='me-3' />
                                            Delete
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                setMuteContact(true);
                                                handleMenuClose();
                                            }}
                                            style={{ color: '#0044C6' }}
                                        >
                                            <VolumeOffIcon className='me-3' />
                                            Mute
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                handleDelete();
                                                handleMenuClose();
                                            }}
                                            style={{ color: '#0044C6' }}
                                        >
                                            <BlockIcon className='me-3' />
                                            Block
                                        </MenuItem>
                                    </Menu>
                                </div>
                            }

                        </div>
                    </div>
                </div>
                <SpeedDialComponent />
                <LayoutBox deleteConfirm={deleteConfirm} setdeleteConfirm={setdeleteConfirm}
                    handleDeleteCard={handleDelete}
                    muteContact={muteContact} setMuteContact={setMuteContact} />

            </div>
        </>
    );
}

const LayoutBox = ({ deleteConfirm, setdeleteConfirm, handleDeleteCard, muteContact, setMuteContact, handleSaveMute }) => {

    const [selectedOption, setSelectedOption] = useState('');

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
    };

    return (
        <>
            {deleteConfirm &&
                <div className="lightbox-overlay">
                    <div className="lightbox-content p-4" style={{ minWidth: "40%" }}>
                        <div className='d-flex align-items-center justify-content-between'>
                            <h6 className='mb-0' style={{ fontSize: "16px", fontWeight: "bold", color: "black" }}>Delete the Contact</h6>
                            <IconButton onClick={() => setdeleteConfirm(false)}>
                                <CloseRoundedIcon />
                            </IconButton>
                        </div>

                        <Typography variant="body2" className="text-muted">Group will be deleted from your Contact Group. Are you sure you want to delete?</Typography>

                        <div className='d-flex justify-content-end'>
                            <Button onClick={() => setdeleteConfirm(false)} className="mx-2 mt-2">
                                CANCEL
                            </Button>
                            <Button onClick={handleDeleteCard} className="delete-button_configuration mt-2">
                                DELETE
                            </Button>
                        </div>

                    </div>
                </div>
            }

            <Dialog open={muteContact} onClose={() => { setMuteContact(false) }} maxWidth="sm">
                <DialogTitle className='d-flex'>
                    Mute the Contact
                    <IconButton
                        aria-label="close"
                        onClick={() => { setMuteContact(false) }}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 10,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <FormControl component="fieldset">
                        <RadioGroup value={selectedOption} onChange={handleChange}>
                            <FormControlLabel value="1 hour" control={<Radio />} label="1 hour" />
                            <FormControlLabel value="8 hours" control={<Radio />} label="8 hours" />
                            <FormControlLabel value="7 days" control={<Radio />} label="7 days" />
                            <FormControlLabel value="indefinite" control={<Radio />} label="Until I Turn It Back On" />
                        </RadioGroup>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <div className='d-flex justify-content-end'>
                        <Button onClick={() => setMuteContact(false)} className="me-3" style={{ color: "#0044c6" }}>
                            CANCEL
                        </Button>
                        <Button onClick={() => { handleSaveMute(selectedOption) }} variant="contained" className='color-white' sx={{ backgroundColor: "#0044C6" }}
                            style={{ marginBottom: "10px", marginRight: "10px" }}>
                            Confirm
                        </Button>
                    </div>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default AllGroupDetails;
